import { GxIcon, GxSelect } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import { arrowBottomIcon } from '@/images'
import React from 'react'
import style from './styles/select.module.scss'
import ErrorText from '../ErrorText'

interface SelectProps {
  name?: string
  theme?: string
  className?: string
  required?: boolean
  label?: string
  children?: any
  error?: string
  errorText?: string
  placeholder?: string
  value?: string
  clearable?: boolean
}

const Select = ({
  children,
  className = '',
  label,
  theme = 'gray',
  required = false,
  error = '',
  ...props
}: SelectProps): React.ReactElement => {
  return (
    <GxSelect
      label={label}
      required={required}
      distance={10}
      className={classNames({
        [style.default]: true,
        [style[`theme_${theme}`]]: Boolean(theme),
        [className]: className
      })}
      {...props}
    >
      {children}
      <GxIcon src={arrowBottomIcon} slot='icon' className={style.icon} />
      {error !== '' ? <ErrorText text={error} /> : undefined}
    </GxSelect>
  )
}

export default Select
